export default function () {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    // { label: "状态", prop: "status", slots: "status" },
    // { label: "活动名称", prop: "title", width: 160, },
    { label: "参赛宣言", prop: "message", },
    {
      label: "创建日期",
      prop: "createTime",
      width: 180,
    },
    {
      label: "操作",
      prop: "operation",
      width: 120,
      slots: "operation",
      fixed: "right",
    },
  ];
}
